import { Directive, OnDestroy, OnInit, input } from '@angular/core';

import { JackpotRibbonComponent } from './jackpot-ribbon.component';
import { JackpotValueSerializer } from './jackpot-value-serializer.service';

export const __JACKPOT_MAP_BROADCAST_EVENT__ = 'cs-jackpot-map-broadcast';
export const __JACKPOT_VALUE_QUERY_EVENT__ = 'cs-jackpot-value-query';

@Directive({
    selector: '[csWithJackpotValueEventHydrator]',
    standalone: true,
})
export class JackpotValueEventHydratorDirective implements OnInit, OnDestroy {
    jackpotGameId = input<string>('');
    broadcastEventName = input<string>(__JACKPOT_MAP_BROADCAST_EVENT__);
    queryEventName = input<string>(__JACKPOT_VALUE_QUERY_EVENT__);

    constructor(
        private readonly jackpotRibbon: JackpotRibbonComponent,
        private readonly valueSerializer: JackpotValueSerializer,
    ) {}

    ngOnDestroy(): void {
        removeEventListener(__JACKPOT_MAP_BROADCAST_EVENT__, this.jackpotMapBroadcastHandler);
    }

    ngOnInit(): void {
        addEventListener(this.broadcastEventName(), this.jackpotMapBroadcastHandler);
        this.queryAndUpdateJackpotValue(this.queryEventName());
    }

    queryAndUpdateJackpotValue(queryEventName: string): void {
        let jpValueDetail = {
            gameId: this.jackpotGameId(),
            value: {
                isHotJackpotGroup: false,
                amount: '',
            },
        };
        dispatchEvent(new CustomEvent(queryEventName, { detail: jpValueDetail }));
        this.updateValue(jpValueDetail.value.isHotJackpotGroup, jpValueDetail.value.amount);
    }

    private jackpotMapBroadcastHandler = (ev: CustomEventInit): void => {
        const jackpotMap = (ev.detail ?? {}) as Map<string, { readonly amount?: string; readonly isHotJackpotGroup: boolean }>;
        this.updateValue(jackpotMap.get(this.jackpotGameId())?.isHotJackpotGroup ?? false, jackpotMap.get(this.jackpotGameId())?.amount ?? '');
    };

    private updateValue(isHotJackpotGroup: boolean, valueStr: string): void {
        const deserializedValue = this.valueSerializer.deserialize(valueStr);
        this.jackpotRibbon.isJackpotGroup.set(isHotJackpotGroup);
        this.jackpotRibbon.currentValue = deserializedValue;
    }
}
